<template>
  <div class="main">
    <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
      <div class="actions">
        <h3 style="font-size: 28px; line-height: 45px">Sales By Locations</h3>
      </div>
      <div>
        <div class="card-container">
          <div class="requestActions">
            <!-- <a-form-model
                            :model="orderform"
                        >
                            <a-form-model-item>
                                <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                    <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                </a-input>
                            </a-form-model-item>
                        </a-form-model> -->
            <div class="mx-4 pt-1">
              <a-range-picker @change="onCategoryChange"></a-range-picker>
            </div>
            <a-button @click="exportExcell" style="
              width: 159px;
              height: 38px;
              margin-right: 10px;
              border-raduis: 5px;
              background: #418a49;
              color: #fff;
            " icon="export">
              Export
            </a-button>
            <!-- <a-button style="height:38px; border-raduis:5px; background: #ffffff" icon="filter">
                            Click to apply Filter
                        </a-button> -->
          </div>
          <div>
            <a-table :columns="columns" :data-source="tableData" :loading="tableLoading" :pagination="{ pageSize: 20 }"
              class="tableStyle">
              <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                style="padding: 8px">
                <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                  @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                  Search
                </a-button>
                <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                  Reset
                </a-button>
              </div>
              <template slot="action" slot-scope="data">
                <a-dropdown>
                  <a style="color: #98c14b" class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                    <a-icon style="font-size: 25px" type="ellipsis" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a @click="showInvoicesProducts(data)">Preview?</a>
                    </a-menu-item>
                    <a-menu-item>
                      <a @click="downloadInvoice(data)">Download?</a>
                    </a-menu-item>
                    <!-- <a-menu-item v-if="user.isActive === true">
                                                <a @click="showDisableModal(user)">
                                                    Disable User?
                                                </a>
                                            </a-menu-item> -->
                    <!-- <a-menu-item v-if="user.isActive === false">
                                                <a @click="showChangePassword(user)"> Enable User?</a>
                                            </a-menu-item> -->
                  </a-menu>
                </a-dropdown>
              </template>

              <template slot="status" slot-scope="data">
                <status-component :status="data"></status-component>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import _ from "lodash";
import XLSX from "xlsx";
import { NotificationMixins } from "@/mixins/NotificationMixins";

const columns = [
  //   {
  //     title: 'ID',
  //     // width: 150,
  //     key: 'id',
  //     dataIndex: 'id',
  //   },

  {
    title: "Location Name",
    dataIndex: "locationName",
    key: "locationName",
    width: 200,
    scopedSlots: {
    filterDropdown: 'filterDropdown',
    filterIcon: 'filterIcon',
    },
    onFilter: (value, record) =>
        record.locationName
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
  },
  {
    title: "Quantity",
    dataIndex: "totalQuantitySold",
    key: "totalQuantitySold",
    width: 200,
  },

  {
    title: "Gross Sales",
    dataIndex: "totalSales",
    key: "totalSales",
    width: 200,
  },
  {
    title: "Cost Of Goods",
    dataIndex: "totalCostPrice",
    key: "totalCostPrice",
    width: 200,
  },
  {
    title: "Profits",
    dataIndex: "totalProfit",
    key: "totalProfit",
    width: 200,
  },
  //   {
  //     title: 'Margin',
  //     dataIndex: 'margin',
  //     key: 'margin',
  //     // width: 150,
  //   },
  //   {
  //     title: 'Status',
  //     key: 'status',
  //     dataIndex: 'status',
  //     scopedSlots: { customRender: 'status' }
  //   },
  //   {
  //     title: 'Action',
  //     key: 'action',
  //     dataIndex: 'action',
  //     scopedSlots: { customRender: 'action' }
  //   },
];

export default {
  name: "SalesLocation",
  mixins: [NotificationMixins],
  data() {
    return {
      tableData: [],
      tableLoading: false,
      columns,
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      startDate: moment().startOf('year'),
      endDate: moment(),
      rules: {
        notes: [
          {
            required: true,
            message: "Please this field cannot be empty",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions(["getSalesByLocation"]),
    handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        this.searchText = selectedKeys[0];
        this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
        clearFilters();
        this.searchText = '';
        this.loadSalesLocation()
    },
    async loadAllRetailers() {
      const response = await this.getAllRetailers();
      if (response.status === 200) {
        this.availableRetailers = response.data.data;
      } else {
        console.log("Error | ", response);
      }
    },
    onCategoryChange(dateString){
        this.startDate = dateString[0];
        this.endDate = dateString[1];
        this.loadSalesLocation()
    },
    exportExcell() {
      // console.log("tableAllOrdersData | ", this.tableAllOrdersData)
      const dataToExport = [
        [
          "Location",
          "Quantity",
          "Gross Sales",
          "Cost Of Goods",
          "Profits",
        ],
      ];

      this.tableData.forEach((v) => {
        dataToExport.push([
          v.locationName,
          v.totalQuantitySold,
          v.totalSales,
          v.totalCostPrice,
          v.totalProfit,
        ]);
      });

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(dataToExport);

      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

      /* generate file and send to client */
      XLSX.writeFile(
        wb,
        `Export-Sales-Location-${moment().format("DD-MM-YYYY")}.xlsx`
      );
      this.showSuccessAlert("Data Successfully Exported");
    },

    async loadSalesLocation() {
      this.tableLoading = true;
      let req_data = {
        startDate: this.startDate,
        endDate: this.endDate,
      };

      const response = await this.getSalesByLocation(req_data);

      this.tableLoading = false;
      if (response.status === 200) {
        let productList = response.data.data.map((productItem) => ({
          key: productItem.locationId,
          locationName: productItem.locationName
            ? productItem.locationName
            : "N/A",
          totalQuantitySold: productItem.totalQuantitySold
            ? productItem.totalQuantitySold
            : 0,
          totalSales: productItem.totalSales ? productItem.totalSales : 0.0,
          totalCostPrice: productItem.totalCostPrice
            ? productItem.totalCostPrice
            : 0.0,
          totalProfit: productItem.totalProfit ? productItem.totalProfit : 0.0,
        }));

        productList = _.orderBy(productList, ["totalSales"], ["desc"]);

        this.tableData = productList.map((item) => ({
          key: item.key,
          locationName: item.locationName,
          totalQuantitySold: item.totalQuantitySold.toLocaleString(undefined, {
            minimumFractionDigits: 0,
          }),
          totalSales: item.totalSales.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }),
          totalCostPrice: item.totalCostPrice.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }),
          totalProfit: item.totalProfit.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }),
        }));
      } else {
        console.log("Error | ", response);
      }
    },
  },
  computed: {},
  created() {
    // if(this.allOrders){
    //     this.allOrders()
    // }

    if (this.loadSalesLocation) {
      this.loadSalesLocation();
    }
  },
};
</script>

<style scoped>
.requestActions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.actions {
  display: flex;
  justify-content: space-between;
}

.card-container {
  background: none;
  overflow: hidden;
  height: 100vh;
  /* padding: 24px; */
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container
  >>> .ant-tabs.ant-tabs-card
  .ant-tabs-card-bar
  .ant-tabs-tab-active {
  height: 40px;
  color: #98c14b;
  background: #e5efe7;
  border-color: #e5efe7;
  border-bottom: 1px solid #98c14b;
}
.card-container >>> .ant-tabs-tab {
  height: 40px;
  margin: 0;
  width: 217px;
  margin-right: 2px;
  padding: 0 16px;
  line-height: 38px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
}
.card-container >>> .ant-tabs-tab:hover {
  color: #98c14b;
  /* background: #e5efe7; */
}

.modalStyle >>> .ant-modal-header {
  border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
  border-top: none;
}
.modalStyle {
  display: flex;
  justify-content: center;
}

.card-container >>> .ant-badge-count {
  z-index: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  color: #fff;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #98c14b;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #fff;
}

.spinner >>> .ant-spin-dot-item {
  background-color: #418a49;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}

.ant-table-wrapper {
  zoom: 1;
  background: #fff;
  margin-bottom: 30px;
}

button:hover {
  color: #418a49;
  outline-color: #418a49;
  border-color: #418a49;
}
.orderTable >>> .ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.orderTable >>> .ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.orderTable >>> .ant-pagination-item-active a {
  color: #fff;
}
.orderTable >>> .ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableFixHead {
  overflow-y: auto;
  height: 200px;
}
.tableFixHead thead th {
  position: sticky;
  top: 0;
}
.tableFixHead table {
  border-collapse: collapse;
  width: 100%;
}
.tableFixHead th,
.tableFixHead td {
  padding: 8px 16px;
  border: 1px solid #ccc;
}
.tableFixHead th {
  background: #eee;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background: #26A246;
  color: #fff;

}

.tableStyle>>>.ant-table-thead th {
  background: #fff;
  height: 63px;
}

.tableStyle>>>.ant-table-header {
  background: #fff !important;
}
</style>